var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSwapSolid = function SvgSwapSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.082 4.306c-.138-.522.287-1.16 1.137-2.434C11.921.819 12.272.292 12.748.19a1.2 1.2 0 0 1 .505 0c.476.103.827.63 1.529 1.682.85 1.275 1.274 1.912 1.136 2.434a1.2 1.2 0 0 1-.261.49C15.299 5.2 14.533 5.2 13 5.2c-1.532 0-2.298 0-2.656-.405a1.199 1.199 0 0 1-.262-.489ZM.082 11.694c-.138.522.287 1.16 1.137 2.434.702 1.053 1.053 1.58 1.528 1.682.167.036.34.036.506 0 .476-.103.827-.63 1.529-1.682.85-1.275 1.274-1.912 1.136-2.434a1.2 1.2 0 0 0-.261-.49C5.298 10.8 4.532 10.8 3 10.8s-2.298 0-2.656.405a1.2 1.2 0 0 0-.262.489Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.5 4.25c-.69 0-1.25.56-1.25 1.25V14a1.25 1.25 0 1 1-2.5 0V5.5a3.75 3.75 0 1 1 7.5 0v6a1.25 1.25 0 1 0 2.5 0V3a1.25 1.25 0 1 1 2.5 0v8.5a3.75 3.75 0 0 1-7.5 0v-6c0-.69-.56-1.25-1.25-1.25Z",
    clipRule: "evenodd"
  })));
};
export default SvgSwapSolid;